import { Controller } from "@hotwired/stimulus"

// Dibuja los diagramas de la guía de uso. Mermaid pesa cerca de 1 MB, así que
// se trae del CDN sólo en las páginas que lo usan en vez de ir en el bundle.
const MERMAID_URL = "https://cdn.jsdelivr.net/npm/mermaid@11/dist/mermaid.esm.min.mjs"

export default class extends Controller {
  async connect() {
    const { default: mermaid } = await import(MERMAID_URL)

    mermaid.initialize({ startOnLoad: false, theme: this.dark ? "dark" : "neutral", fontFamily: "Inter, sans-serif" })
    await mermaid.run({ nodes: this.element.querySelectorAll("pre.mermaid:not([data-processed])") })
  }

  get dark() {
    const chosen = document.documentElement.getAttribute("data-adm-theme")
    return chosen ? chosen === "dark" : window.matchMedia("(prefers-color-scheme: dark)").matches
  }
}
